import { Clusters } from 'components/clusters';

const ClustersPage = () => {
  return <Clusters />;
};

export default ClustersPage;
